import { accessNested } from 'utils/utils';

// Gets a copy value, and replaces %$THING% by other copy data
// Example:
// copy = {
// 	'$MSG': 'Hello %$NAME%',
// 	'$NAME': '%$FIRST_NAME% %$SURNAME%',
// 	'$FIRST_NAME': 'John',
// 	'$SURNAME': 'Doe'
// };
// getCopyWithParams(copy, '$MSG'); // Hello John Doe
// getCopyWithParams(copy, 'Bye %$NAME%'); // Bye John Doe (if attribute is not a copy element, it uses that value directly)
// getCopyWithParams(copy, '%$FIRST_NAME% is %$MOOD%'); // John is $MOOD (if a variable is not defined, outputs its name)
// getCopyWithParams(copy, '100% with %$SURNAME%'); // 100% with Doe (a % sign alone still works)
// getCopyWithParams(copy, 'a \\%protected% part'); // a %protected% part (prepend with a \ to prevent parsing ; warning : needs to be doubled in string literals because of default JS escaping)
function _getCopyWithParams(copy, attribute, _n) {
	// Prevent infinite recursion (e.g. $A = %$B%, $B = %$A%)
	if (++_n > 10) return attribute;
	// Allows using %subObject.$VALUE%
	const content = accessNested(copy, attribute, attribute) + '';
	return content.replace(/(\\)?%([^% ]+)%/g, (_, backslash, val) => backslash ? '%' + val + '%' : _getCopyWithParams(copy, val, _n));
}
export default function getCopyWithParams(copy, attribute) {
	return _getCopyWithParams(copy, attribute, 0);
}